/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @fileoverview Locale-aware CSV column headers for attendance export by event type.
 * @module logic/attendance/csvHeaders
 */
import i18n from "../../i18n.js";

const attendanceCsvKey = (suffix) => `exports.attendanceCsv.${suffix}`;
const BREAKFAST_SHARED_HEADER_COUNT = 4;

const getSharedAttendanceHeaders = () => [
  i18n.t(attendanceCsvKey("fullName")),
  i18n.t(attendanceCsvKey("email")),
  i18n.t(attendanceCsvKey("memberNumber")),
  i18n.t(attendanceCsvKey("userRfc")),
  i18n.t(attendanceCsvKey("tradeName")),
];

export const getBusinessEventCsvHeaders = () => [
  ...getSharedAttendanceHeaders(),
  i18n.t(attendanceCsvKey("buyerCompanyName")),
  i18n.t(attendanceCsvKey("requirementName")),
  i18n.t(attendanceCsvKey("eventDate")),
  i18n.t(attendanceCsvKey("attended")),
];

export const getB2BEventCsvHeaders = () => [
  ...getSharedAttendanceHeaders(),
  i18n.t(attendanceCsvKey("eventDate")),
  i18n.t(attendanceCsvKey("attended")),
];

export const getBreakfastEventCsvHeaders = () => [
  ...getSharedAttendanceHeaders().slice(0, BREAKFAST_SHARED_HEADER_COUNT),
  i18n.t(attendanceCsvKey("companyName")),
  i18n.t(attendanceCsvKey("eventDate")),
  i18n.t(attendanceCsvKey("attended")),
];

export const getDefaultEventCsvHeaders = () => [
  i18n.t(attendanceCsvKey("fullName")),
  i18n.t(attendanceCsvKey("email")),
  i18n.t(attendanceCsvKey("phone")),
  i18n.t(attendanceCsvKey("tradeNameShort")),
  i18n.t(attendanceCsvKey("legalName")),
  i18n.t(attendanceCsvKey("memberOrNot")),
  i18n.t(attendanceCsvKey("attended")),
  i18n.t(attendanceCsvKey("rfc")),
  i18n.t(attendanceCsvKey("sector")),
  i18n.t(attendanceCsvKey("subsector")),
  i18n.t(attendanceCsvKey("branch")),
  i18n.t(attendanceCsvKey("totalEmployees")),
  i18n.t(attendanceCsvKey("operationScope")),
  i18n.t(attendanceCsvKey("position")),
  i18n.t(attendanceCsvKey("area")),
  i18n.t(attendanceCsvKey("gender")),
  i18n.t(attendanceCsvKey("businessInterests")),
  i18n.t(attendanceCsvKey("expectations")),
];

/**
 * @param {string|undefined} eventType
 * @returns {string[]}
 */
export const getCsvHeadersForEventType = (eventType) => {
  if (eventType === "BUSINESS_EVENT") {
    return getBusinessEventCsvHeaders();
  }
  if (eventType === "B2B_EVENT") {
    return getB2BEventCsvHeaders();
  }
  if (eventType === "BREAKFAST_EVENT") {
    return getBreakfastEventCsvHeaders();
  }
  return getDefaultEventCsvHeaders();
};
